module.exports = __webpack_public_path__ + "static/media/arts_12.7e3a4d6d.jpg";